<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text } from '@Shelly/shelly-design-system/index';
	//Helpers
	import TemplateInputSettings from '../../Components/TemplateInputSettings.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	const unit = 'min';
	let disabled: boolean = false;
	let value = 0;
</script>

<TemplateInputSettings
	{device}
	setting="global_time_limit"
	min={0}
	max={1440}
	{unit}
	bind:value
	bind:disabled
	withCheckbox
>
	<hr class="mt-s mb-m" />
	<Text styleType="body-small" class="mb-s{disabled ? ' text-color-muted' : ''}"
		>{$format('ev_charger_global_time_limit', {
			default: 'Configure the EV charger to stop charging when the session duration reaches',
		})}
		<span class="mb-s{disabled ? ' text-color-muted' : 'text-primary'}"
			>{disabled || value === null ? '--' : value}</span
		>
		{unit}.
	</Text>
</TemplateInputSettings>
